import { createContext, forwardRef, useContext, type AnchorHTMLAttributes, type ForwardRefExoticComponent, type RefAttributes } from 'react'

export type UiLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }
export type UiLinkComponent = ForwardRefExoticComponent<UiLinkProps & RefAttributes<HTMLAnchorElement>>

const PlainLink: UiLinkComponent = forwardRef<HTMLAnchorElement, UiLinkProps>(function PlainLink(props, ref) {
  return <a ref={ref} {...props} />
})

const LinkContext = createContext<UiLinkComponent>(PlainLink)

/** Apps provide their router's link (client-side navigation) here. */
export const UiLinkProvider = LinkContext.Provider

/** Internal link: renders the app's router link, or a plain anchor. */
export const UiLink = forwardRef<HTMLAnchorElement, UiLinkProps>(function UiLink(props, ref) {
  const L = useContext(LinkContext)
  return <L ref={ref} {...props} />
})

/** Paths used by kit components; one place to change the URL scheme. */
export const paths = {
  agent: (handle: string, tab?: string) => (tab ? `/a/${handle}?tab=${tab}` : `/a/${handle}`),
  manage: (handle: string) => `/a/${handle}/manage`,
  token: (address: string) => `/tokens/${address}`,
  /** The account's trading wallet (one per account, lane BOOCLEAN1). */
  wallet: () => '/portfolio/wallet',
  user: (handle: string) => `/u/${handle}`,
}
